import { CornerStyle, CommonLayout, Height, ButtonStyle } from '@atlassian/company-hub-common';
import { ITEM_FIELDS as FRAME_FIELDS } from '../shared-components/ConfigPanel/configPanelTypes';

export type CarouselParameters = {
	cards: Frame[];
	cornerStyle?: CornerStyle;
	extensionTitle: string;
	isAutoplayEnabled?: boolean;
	navigationStyle?: NavigationStyle;
	version: string;
};

export type Frame = {
	[FRAME_FIELDS.CARD_ID]: string;
	[FRAME_FIELDS.LINK]: string;
	[FRAME_FIELDS.IS_LINK_USER_EDITED]?: boolean;
	[FRAME_FIELDS.TITLE]?: string;
	[FRAME_FIELDS.IS_TITLE_USER_EDITED]?: boolean;
	[FRAME_FIELDS.DESCRIPTION]?: string;
	[FRAME_FIELDS.IS_DESCRIPTION_USER_EDITED]?: boolean;
	[FRAME_FIELDS.IMAGE_SRC]?: string;
	[FRAME_FIELDS.IMAGE_ALT_TEXT]?: string;
	[FRAME_FIELDS.CONFLUENCE_PAGE_ID]?: string;
	[FRAME_FIELDS.BACKGROUND_COLOR]?: string;
	[FRAME_FIELDS.TEXT_COLOR]?: string;
	[FRAME_FIELDS.LAYOUT]?: CommonLayout;
	[FRAME_FIELDS.BUTTON_TEXT]?: string;
	[FRAME_FIELDS.BUTTON_STYLE]?: ButtonStyle;
	[FRAME_FIELDS.HEIGHT]?: Height;
};

export enum NavigationStyle {
	PROGRESS_CIRCLES = 'progress-circles',
	THUMBNAILS = 'thumbnails',
}

export { CornerStyle, CommonLayout, Height, ButtonStyle };

export enum FrameSizes {
	NAVIGATION_THUMBNAIL = 'navigationThumbnail',
	NAVIGATION_THUMBNAIL_V2 = 'navigationThumbnailV2',
	HERO = 'hero',
}

export { FRAME_FIELDS };

export type ResolvedLinkDataObject = {
	data: {
		summary?: string;
		name?: string;
		image?: {
			url?: string;
		};
	};
	meta: {
		objectId?: string;
		resourceType?: string;
	};
};
